import { forwardRef, type InputHTMLAttributes, useId } from "react";

import classNames from "classnames";

import style from "./SegmentedControl.module.css";

export type SegmentedControlProps = {
  className?: string;
  optionA: string;
  optionB: string;
  optionASecondaryText?: string;
  optionBSecondaryText?: string;
};

export const SegmentedControl = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & SegmentedControlProps
>(({ className, optionA, optionASecondaryText, optionB, optionBSecondaryText, ...attrs }, ref) => {
  const id = useId();

  return (
    <div className={classNames(style.segmentedControl, className)}>
      <input id={id} ref={ref} {...attrs} type="checkbox" className={style.input} />
      <label htmlFor={id} className={classNames(style.option, style.optionA)}>
        <span className={style.optionContent}>
          <span className={style.optionLabel}>{optionA}</span>
          {optionASecondaryText && (
            <span
              className={classNames(style.optionLabel, style.optionSecondaryText)}
            >{` ${optionASecondaryText}`}</span>
          )}
        </span>
      </label>
      <label htmlFor={id} className={classNames(style.option, style.optionB)}>
        <span className={style.optionContent}>
          <span className={style.optionLabel}>{optionB}</span>
          {optionBSecondaryText && (
            <span
              className={classNames(style.optionLabel, style.optionSecondaryText)}
            >{` ${optionBSecondaryText}`}</span>
          )}
        </span>
      </label>
    </div>
  );
});

SegmentedControl.displayName = "SegmentedControl";
